import { ITableColumn } from 'src/app/core/models/table.model';
import { createTokenQueryServiceInstance } from 'src/app/core/services/query.service';
import { getStatusIcon, IControlliEffettuati, IPuntoCampionamento } from './punti-campionamento.model';
import { SignalStoreConfig } from 'src/app/shared/functions/store.functions';
import { QueryState } from 'src/app/core/models/query.model';

export const CONTROLLO_DETTAGLIO_ENDPOINT = 'last-dati-prelievo';
export const CONTROLLO_DETTAGLIO_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(CONTROLLO_DETTAGLIO_ENDPOINT);



export const controlloDettaglioStateConfig: SignalStoreConfig<QueryState<IControlliEffettuati>> = {
  initState: {
    list: [],
    sort: {
      field: 'uuid',
      direction: 'asc'
    }
  }
}

export const CONTROLLO_DETTAGLIO_COLUMNS: ITableColumn[] = [
  {
    name: 'definizione',
    label: 'Definizione',
    field: 'definizione',
  },
  {
    name: 'unitaDiMisura',
    label: 'unita di misura',
    field: 'unitaDiMisura',
  },
  {
    name: 'dataOraPrelievo',
    label: 'data Ora Prelievo',
    field: 'dataOraPrelievo',
    type: 'datetime',
  },
  {
    name: 'valoreRapportoProva',
    label: 'valore',
    field: 'valoreRapportoProva',
  },
  {
    name: 'valoreArrotondato',
    label: 'Valore Arrotondato',
    field: 'valoreArrotondato',
  },
  {
    name: 'status',
    label: 'Status',
    field: 'status',
    classes: { 'pl-4': true },
    cell: (element: IControlliEffettuati) => getStatusIcon(element.status)
  },
];


export const CONTROLLO_DETTAGLIO_VISIBLECOLUMNS= [
  'definizione',
  'unitaDiMisura',
  'dataOraPrelievo',
  'valore',
  'valoreArrotondato',
  'status'
];